import React from "react";
import { Link } from "react-router-dom";
import { useContextUsuario } from '../../contexto/usuario/UsuarioContext';
import ModalBootstrap from "../modal/ModalBootstrap";
import CarritoCotizaciones from "./CarritoCotizacion";

const ModalCarritoCotizacion = ({ modalIsOpen, setModalIsOpen, carritoCotizacion }) => {
  const { usuario } = useContextUsuario();
  const isEmpleado = usuario?.tipo === "Empleado";

  const rutaCotizaciones = isEmpleado ? "/app/admin/cotizaciones/editar" : "/app/clientes/cotizaciones/nuevo"; 

  return (
    <ModalBootstrap
      estiloBoton="btn btn-link text-secondary p-0"
      iconBoton="fa-solid fa-cart-arrow-down text-white"
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      titulo={isEmpleado ? "Cotizaciones Pendientes" : "Cotizaciones"}
      pie={
        <Link
          to={rutaCotizaciones} // Actualizada la ruta
          className="btn btn-primary mx-2"
          style={{ fontSize: "16px" }}
        >
          {isEmpleado ? "Ver Cotizaciones Pendientes" : "Guardar mis cotizaciones"}
        </Link>
      }
    >
      <CarritoCotizaciones carritoCotizacion={carritoCotizacion} isEmpleado={isEmpleado} />
    </ModalBootstrap>
  );
};

export default ModalCarritoCotizacion;